import React from 'react';

import {
  DashboardPage,
  DocsPage,
  ProfilePage,
  ProjectDetailsPage,
  ProjectsPage,
  SupportPage,
  TestAccountPage,
} from '../../pages';
import { RouterPaths } from '../../constants/routes';
import ProtectedFooterRoute, { FooterRouteProps } from './ProtectedFooterRoute';

const DeveloperDashboardRoutes: FooterRouteProps[] = [
  {
    Component: DashboardPage,
    exact: true,
    path: RouterPaths.dashboard,
  },
  {
    Component: ProjectsPage,
    exact: true,
    path: RouterPaths.projects,
  },
  {
    Component: ProjectDetailsPage,
    path: RouterPaths.projectDetails,
  },
  {
    Component: DocsPage,
    path: RouterPaths.docs,
  },
  {
    Component: ProfilePage,
    path: RouterPaths.profile,
  },
  {
    Component: TestAccountPage,
    path: RouterPaths.test,
  },
  {
    Component: SupportPage,
    path: RouterPaths.support,
  },
];

const DeveloperDashboardNavigator = DeveloperDashboardRoutes.map((route) => (
  <ProtectedFooterRoute key={route.path} margin {...route} />
));

export default DeveloperDashboardNavigator;
